import { render, staticRenderFns } from "./ModelShareDialog.vue?vue&type=template&id=5cd7c676&scoped=true"
import script from "./ModelShareDialog.vue?vue&type=script&lang=js"
export * from "./ModelShareDialog.vue?vue&type=script&lang=js"
import style0 from "./ModelShareDialog.vue?vue&type=style&index=0&id=5cd7c676&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd7c676",
  null
  
)

export default component.exports